import * as React from 'react';

import { cn } from '@/lib/utils';

/** Opted out of autofill for the same reason as `Input`. */
const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, autoComplete = 'off', ...props }, ref) => {
    return (
      <textarea
        autoComplete={autoComplete}
        data-1p-ignore={autoComplete === 'off' ? '' : undefined}
        data-lpignore={autoComplete === 'off' ? 'true' : undefined}
        data-form-type={autoComplete === 'off' ? 'other' : undefined}
        className={cn(
          'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
